import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Unidades } from './unidades';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnidadService {


  constructor(private http: HttpClient) { }

 
  getUnidades(idEmisor: string) {  
    
    return this.http.get<Unidades[]>(environment.apiUrl+"/listarUnidades/?idEmisor=" + idEmisor);  
  }  

  getUnidad(idUnidad: string) {  
    
    return this.http.get<Unidades[]>(environment.apiUrl+"/listarUnidad/?id=" + idUnidad);  
  }  

  getUnidadesCompra(idEmisor: string) {  
    
    return this.http.get<Unidades[]>(environment.apiUrl+"/listarUnidadCompra/?id=" + idEmisor);  
  }  

  getUnidadesVenta(idEmisor: string) {  
    
    return this.http.get<Unidades[]>(environment.apiUrl+"/listarUnidadVenta/?id=" + idEmisor);  
  }  

  

  setActulizar(unidades: Unidades[]){
    console.log(unidades);
    return this.http.put<string>(environment.apiUrl+"/actulizarUnidades",unidades)
  }

  eliminar(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarUnidades/?id="+id);
  }
  
}
